import React from 'react'

import FormManager from '../../../core/gd-form/common/form-manager'
import DatepickerContent from '../../../core/gd-components/datetime/datepicker/datepicker-content'

type Props = {
    params: {
        btnNoValueLabel : string

        minDate?        : Moment | null
        btnSomeday      : boolean
        btnTomorrow     : boolean
        btnToday        : boolean
        btnNoValue      : boolean

        onSubmit        : callback
    }
}

export default class SelectDate extends React.Component<Props> {

    public form: FormManager

    constructor(props: Props) {
        super(props);

        const initFormData = {
            date    : null,
            state   : null
        }

        const formStructure = {
            fields  : {
                date    : {
                    type        : 'select',
                    isRequired  : false
                },
                state   : {
                    type        : 'select',
                    isRequired  : false
                }
            },
            onSubmit: this.onSubmit
        }

        this.form = new FormManager(formStructure,initFormData)
    }

    onSubmit = (result) => {
        this.props.params.onSubmit(result.date, result.state)
    }

    onSelect = (moment) => {
        this.form.setValue('date', moment)
        this.form.onSubmitClick()
    }

    onSelectSomeday = () => {
        this.form.setValue('date', null)
        this.form.setValue('state', gd.const.task.scheduleStatus.SOMEDAY)
        this.form.onSubmitClick()
    }

    render() {
        const value = this.form.getValue('date');

        const minDate = moment.isMoment(this.props.params.minDate) ? this.props.params.minDate : this.props.params.minDate === null ? null : moment()

        return (
            <div className="gd-form-modal">
                <div className="row">
                    <DatepickerContent value                = {value}
                                       onSelect             = {this.onSelect}
                                       onSelectSomeday      = {this.onSelectSomeday}
                                       minDate              = {minDate}
                                       btnNoValue           = {this.props.params.btnNoValue}
                                       btnNoValueLabel      = {this.props.params.btnNoValueLabel}
                                       btnSomeday           = {this.props.params.btnSomeday}
                                       btnToday             = {this.props.params.btnToday}
                                       btnTomorrow          = {this.props.params.btnTomorrow}
                                       customButtonsNoBg    = {true}/>
                </div>
            </div>
        );
    }
}
